import { render, staticRenderFns } from "./DroppedOrderBanner.vue?vue&type=template&id=2e8c13f6&scoped=true"
import script from "./DroppedOrderBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./DroppedOrderBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DroppedOrderBanner.vue?vue&type=style&index=0&id=2e8c13f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c13f6",
  null
  
)

export default component.exports